import React from 'react';
import ClassAssembly  from 'views/ClassAssembly4D';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;